import { __extends } from "tslib";
import { DeleteSegmentRequest, DeleteSegmentResponse } from "../models/models_0";
import { deserializeAws_restJson1DeleteSegmentCommand, serializeAws_restJson1DeleteSegmentCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Deletes a segment from an application.</p>
 */
var DeleteSegmentCommand = /** @class */ (function (_super) {
    __extends(DeleteSegmentCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteSegmentCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DeleteSegmentCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "DeleteSegmentCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: DeleteSegmentRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DeleteSegmentResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteSegmentCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1DeleteSegmentCommand(input, context);
    };
    DeleteSegmentCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1DeleteSegmentCommand(output, context);
    };
    return DeleteSegmentCommand;
}($Command));
export { DeleteSegmentCommand };
//# sourceMappingURL=DeleteSegmentCommand.js.map